import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { AppStorage } from '../../enums/app-storage';
import { Language } from '../../models/language.model';
import { CookieService } from '../cookie/cookie.service';

@Injectable({
  providedIn: 'root',
})
export class LanguageChangeService {
  private readonly platformId = inject(PLATFORM_ID);
  readonly cookieService = inject(CookieService);
  readonly currentLanguage: Language | null = this.cookieService.get(
    AppStorage.language
  ) as Language | null;
  readonly translocoService = inject(TranslocoService);

  constructor() {
    if (isPlatformBrowser(this.platformId)) {
      this.setupStorageListener();
    }
  }

  private setupStorageListener(): void {
    globalThis.addEventListener('storage', event => {
      if (
        event.key === AppStorage.language &&
        event.newValue !== this.currentLanguage
      ) {
        // Reload the page when language is changed from another tab
        this.reloadPage();
      }
    });
  }

  // Public method to manually change language and reload
  changeLanguage(lang: Language): void {
    if (lang !== this.currentLanguage) {
      this.cookieService.set(AppStorage.language, lang);
      this.translocoService.setActiveLang(lang);
      this.reloadPage();
    }
  }

  // Protected for testability
  protected reloadPage(): void {
    location.reload();
  }
}
